import { useEffect, useRef, useState } from 'react'
import Translation from '../../Translation/cont/Translation';
import ButtonSubmit from '../../general/ButtonSubmit';
import { Field, Form, Formik } from 'formik';
import RadioButtonWrapper from '../../forms/fields/RadioButtonWrapper';
import ColorPicker from '../../forms/fields/ColorPicker';
import FieldWrapper from '../../forms/FieldWrapper';
import ImageDisplayAndUpload from '../../forms/fields/ImageDisplayAndUpload';

const getColorFromValue = (value) => {
    return value ? value : 'rgba(59, 59, 59, 1)'
}

const getColorFromPicker = value => `rgba(${value.r}, ${value.g}, ${value.b}, ${value.a})`

const AttributeColorSettingsForm = ({
    attributeColorSettings,
    onUpdateItem,
    removeItem
}) => {
    if(!attributeColorSettings) {
        return ''
    }
    const [initialValues, setInitialValues] = useState(attributeColorSettings)
    const formikRef = useRef();
    useEffect(() => {
        setInitialValues(attributeColorSettings)
        formikRef.current.resetForm()
    }, [attributeColorSettings])

    const sortedAttributes = Object.keys(initialValues).sort(function(a, b) {
        const attrA = initialValues[a].name && initialValues[a].name.toLowerCase()
        const attrB = initialValues[b].name && initialValues[b].name.toLowerCase()
        
        return attrB > attrA ? -1 : attrB < attrA ? 1 : 0
    })

    const displayVariantSettings = [
        {
            "value":"border",
            "transId": "web2print_attributes_display_border"
        }, 
        {
            "value":"background",
            "transId": "web2print_attributes_display_background"
        }
    ]

    return (
        <Formik
            enableReinitialize={true}
            innerRef={formikRef}
            initialValues={initialValues}
            onSubmit={(values, actions) => {
                onUpdateItem(values)
                actions.setSubmitting(false)
            }}
            >
            {({values, errors, touched, isSubmitting, handleReset, setFieldValue}) => 
                <Form>
                    <ButtonSubmit
                        transIdSubmit={'save_button'}
                        hasFixedPositionWrapper={true}
                        disableTemporarily={isSubmitting}
                        disablePermanently={isSubmitting}
                    />

                    <div className='form-wrapper'>
                        <div className='attribute-icon-hint'>
                            <p><Translation id="web2print_attributes_icon_hint" /></p>
                            <p><Translation id="images_uploads_textAccept_sing" /></p>
                        </div>
                        {sortedAttributes.map((attrKey, index) => {
                            const attributeColorSettingData = values[attrKey]
                            if(!attributeColorSettingData) {
                                return ''
                            }

                            const { name, attributeColorSetting, id } = attributeColorSettingData

                            
                            if(!_.has(attributeColorSetting, "iconUrl")) {
                                attributeColorSetting.iconUrl = ''
                            }
                            
                            return <div className='form-content print-attributes-settings' key={index}>
                                    <div className='attribute-name'>{name}</div>

                                    <div className='settings-wrapper'>
                                        {attributeColorSetting && Object.keys(attributeColorSetting).map((key, index) => {
                                            const settingValue = attributeColorSetting[key]

                                            return <div className={'grid-' + (index + 1)} key={index}>
                                                <Translation id={"web2print_attributes_" + key}></Translation>
                                                    {'hide' === key ? (
                                                        <div className='field-text'>
                                                            <label className='hide-attribute-wrapper'>
                                                                <Field 
                                                                    type="checkbox" 
                                                                    checked={settingValue} 
                                                                    id={`${attrKey}.attributeColorSetting.${key}`} 
                                                                    className="checkbox tgl tgl-flat" 
                                                                    onChange={() =>  setFieldValue(`${attrKey}.attributeColorSetting.${key}`, !settingValue)}
                                                                />

                                                                <span className="tgl-btn text-regular">
                                                                    <span className='screen-reader-text'>
                                                                        <Translation id="print_flyer_activate_customization">Aktiv</Translation>
                                                                    </span>
                                                                </span>

                                                                <p className=''><Translation id="web2print_attributes_hide_label"></Translation></p>
                                                            </label>
                                                        </div>
                                                    ) : 'display' === key ? (
                                                            <div className='field-text'>            
                                                                <div className='display-setting'>
                                                                    {displayVariantSettings.map((displaySetting, index) => {
                                                                        const value = displaySetting.value

                                                                        return <div className="field-checkbox" key={index}>
                                                                            <RadioButtonWrapper 
                                                                                id={`${attrKey}.attributeColorSetting.${key}.${value}`} 
                                                                                label={<Translation id={displaySetting.transId}/>}
                                                                            >
                                                                                <Field
                                                                                    id={`${attrKey}.attributeColorSetting.${key}.${value}`}
                                                                                    type="radio"
                                                                                    name={`${attrKey}.attributeColorSetting.${key}`}
                                                                                    value={value}
                                                                                />
                                                                            </RadioButtonWrapper>
                                                                        </div>
                                                                    })}
                                                                </div>
                                                            </div>

                                                    ) : 'color' === key ? (
                                                        <ColorPicker  
                                                            name={settingValue ? settingValue : <Translation id='web2print_attributes_color_default'/>}
                                                            value={getColorFromValue(settingValue)}
                                                            disableAlpha={false}
                                                            onSetValue={
                                                                (color, even) => {
                                                                    if(color && color.hasOwnProperty('rgb')) {
                                                                        setFieldValue(`${attrKey}.attributeColorSetting.${key}`, getColorFromPicker(color.rgb))
                                                                    }
                                                                }
                                                            }
                                                            onReset={() => setFieldValue(`${attrKey}.attributeColorSetting.${key}`, null)}
                                                        />  
                                                  
                                                    ) : 'iconUrl' === key ? (
                                                        <div className='field-text'>
                                                            <Field
                                                                name={`${attrKey}.attributeColorSetting.${key}`}
                                                                component={ImageDisplayAndUpload}
                                                                hideAdditionalText={true}
                                                            />
                                                        </div>
                                                    ) : ''}
                                            </div>
                                        })}
                                    </div>
                                    <div className="button-selection-wrapper odd">
                                        <div className="button icon button-delete button-delete-selection"  onClick={() => {removeItem(attrKey, attributeColorSettings)}}>
                                            <span className="screen-reader-text"><Translation id="formik_delete_element">Element löschen</Translation></span>
                                        </div>
                                    </div>
                                </div>
                        })} 
                    </div>
                
                    <ButtonSubmit
                        transIdSubmit={'save_button'}
                        hasFixedPositionWrapper={true}
                        disableTemporarily={false}
                        disablePermanently={false}
                    />
                </Form>
            }
        </Formik>

    )
}

export default AttributeColorSettingsForm